import http from '../utils/request'

export const getModules = () => http.get('/system/modules')

/** 获取数据源列表（SYSCommonSettings FROM ExternalServer/DataSource） */
export const getDataSources = () => http.get('/system/dataSources')

/** 获取表的字段列表 */
export const getTableColumns = (tableName) => http.get('/system/tableColumns', { params: { tableName } })

/** 获取流程关联的表单字段列表（用于流程变量选择） */
export const getFormFields = (flowGuid) => http.get(`/process/form-fields/${flowGuid}`)
